var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGvcAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "512pt",
    viewBox: "0 -31 512 512",
    width: "512pt",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m91 300h121.761719c7.613281-83.96875 78.320312-150 164.238281-150 25.226562 0 49.058594 5.859375 70.464844 16.023438-11.609375-39.996094-46.148438-70.398438-89.507813-75.203126-13.214843-52.558593-61.039062-90.820312-115.957031-90.820312-42.613281 0-83.105469 23.230469-104.433594 60.027344-36.929687-1.710938-70.105468 27.070312-75.554687 65.230468-35.949219 12.246094-62.011719 46.230469-62.011719 84.742188 0 49.628906 41.371094 90 91 90zm0 0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m377 180c-74.441406 0-135 60.558594-135 135s60.558594 135 135 135 135-60.558594 135-135-60.558594-135-135-135zm60 150h-45v45h-30v-45h-45v-30h45v-45h30v45h45zm0 0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGvcAdd);
export default __webpack_public_path__ + "static/media/gvc-add.ce15b786125ba519233b58147c5a49f6.svg";
export { ForwardRef as ReactComponent };